import { render, staticRenderFns } from "./back-to-store.vue?vue&type=template&id=7c7a4666&scoped=true&"
import script from "./back-to-store.vue?vue&type=script&lang=js&"
export * from "./back-to-store.vue?vue&type=script&lang=js&"
import style0 from "./back-to-store.vue?vue&type=style&index=0&id=7c7a4666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7a4666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
